import {
  string,
  object,
  optional,
  func,
  union,
  array,
  Infer,
} from 'superstruct';

export const SimulateSpecialsPayloadSchema = object({
  tenant_id: string(),
  otp: string(),
});

export const SimulateSpecialsLaunchOptionsSchema = object({});

export const SimulateSpecialsConfigSchema = object({
  iframeContainerId: union([string(), array(string())]),
  iframeSourceUrl: optional(string()),
  onRefreshBalance: optional(func()),
  source: optional(string()),
  locale: optional(string()),
  tenantId: string(),
});

export type SimulateSpecialsPayload = Infer<
  typeof SimulateSpecialsPayloadSchema
>;

export type SimulateSpecialsLaunchOptions = Infer<
  typeof SimulateSpecialsLaunchOptionsSchema
>;

export type SimulateSpecialsConfig = Infer<typeof SimulateSpecialsConfigSchema>;

export interface SimulateSpecialsSDK {
  launch(): Promise<void>;
  remove(): Promise<void>;
}
